import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getSurvey: {
    method: 'GET',
    url: `${configs.baseUrl}/api/survey/crazyegg/{surveyCode}`,
  },
  getActiveSurveysForPresenter: {
    method: 'GET',
    url: `${configs.baseUrl}/api/survey/crazyegg`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getSurvey = async (surveyCode) => {
  const res = await resource.getSurvey({ surveyCode })
  return res.body
}

const getActiveSurveysForPresenter = async () => {
  const res = await resource.getActiveSurveysForPresenter()
  return res.body
}

export default {
  initResource,
  getSurvey,
  getActiveSurveysForPresenter,
}
